import { MERCURY_URL } from '@/constants/env';
import { isAdmin } from '@/utils/usersRole';

import type { TokenInfo } from '../types';

export const useAdminRedirect = () => {
  const isInAdminPath = () => {
    const { pathname } = window.location;

    return pathname.includes('/admin');
  };

  const hasAdminRedirect = (token: TokenInfo) => isAdmin(token.role) && !isInAdminPath();

  const redirectAdmin = () => {
    window.location.replace(`${MERCURY_URL}/admin`);
  };

  const returnToMercuryOrigin = (path: string) => {
    window.location.replace(`${MERCURY_URL}/${path}`);
  };

  return {
    hasAdminRedirect,
    redirectAdmin,
    returnToMercuryOrigin,
    isInAdminPath,
  };
};
